import { DesignStepInfo } from "../apis/designElementsApi";

export const ELEMENTS_QUERY_KEY = (
  layout_body_id: number,
  layout_size_id: number
) => ["elements", layout_body_id, layout_size_id];

export const DESIGN_PREVIEW_QUERY_KEY = (
  design_composition?: string | null,
  layout?: string | null
) => ["design_preview", design_composition, "layout", layout];

export const DESIGN_STEP_OPTIONS_QUERY_KEY = (
  layout?: string | null,
  step_info?: DesignStepInfo | null
) => [
  "design_step_options",
  "layout",
  layout,
  "step_info.step_type",
  step_info?.step_type,
  "step_info.number_of_shapes",
  step_info?.number_of_shapes,
  "step_info.shape_number",
  step_info?.shape_number,
  "step_info.material_number",
  step_info?.material_number,
];
